import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { BudgetList } from "./budgetList"

export const BudgetListLoader = () => (
  <ListLoaderWrapper table={TableName.BUDGETS}>
    <BudgetList />
  </ListLoaderWrapper>
)
